import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { PleaseWait } from '../../comps/PleaseWait';
import { mg } from '../../mg/mg';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';
import { DashboardBody } from './DashboardBody';

@observer export class LDashboard extends OcScreen<{}> {
	name() {
		return 'LDashboard';
	}

	allowScroll() {
		return true;
	}

	usedStores = () => ['Order', 'Template']

	orderFilter = e => {
		return false;
	}

	@computed get _orders() {
		const locationStore = getOmnistore().locationStore;
		const multirepo = getOmnistore().multirepo;
		const templates = multirepo.templateRepo.allAsList.filter(t => t.branchId == locationStore.branchId);
		const templateIdSet = mg.entriesToObject(templates.map(t => [t.id, 1]));
		return multirepo.orderRepo.allAsList.filter(o => templateIdSet[o.templateId]);
	}

	renderBody() {
		const multirepo = getOmnistore().multirepo;
		if (!multirepo.orderRepo.etag) return <PleaseWait/>;
		if (!multirepo.templateRepo.etag) return <PleaseWait/>;
		return <DashboardBody orders={this._orders}/>;
	}
}
